export const RETURN_URL = 'returnUrl';
export const EMAIL = 'email';
export const PREFERRED_LANGUAGE_UNDERSCORE = 'bluebeam_language';
export const PREFERRED_LANGUAGE_DASH = 'bluebeam-language';
export const HIDE_LINKS = 'hideLinks';
